"use client";

import React, { Suspense } from "react";
import QuickContact from "@/components/common/QuickContact";
import UspBannerDesktop from "@/components/newPageComponent/usp/UspBannerDesktop";
import UspRoadmap from "@/components/newPageComponent/usp/UspRoadmap";
import UspBlogs from "@/components/newPageComponent/usp/UspBlogs";
import UspFaq from "@/components/newPageComponent/usp/UspFaq";
import UspHugeShortageDesktop from "@/components/newPageComponent/usp/UspHugeShortageDesktop";
import UspSolutionDesktop from "@/components/newPageComponent/usp/UspSolutionDesktop";
import UspWhatGlobalAccountantsDesktop from "@/components/newPageComponent/usp/UspWhatGlobalAccountantsDesktop";
import UspROIDesktop from "@/components/newPageComponent/usp/UspROIDesktop";
import UspPoweredMilesDesktop from "@/components/newPageComponent/usp/UspPoweredMilesDesktop";
import EventTicker from "@/components/common/EventTicker";
import UspAlumniDesktop from "@/components/newPageComponent/usp/UspAlumniDesktop";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
import StickyFooterLabel from "@/components/newPageComponent/CommonSection/StickyFooterLabel";
import { SectionSkeleton } from "@/components/common/LoadingSkeleton";
import dynamic from "next/dynamic";
const NewInactivityPopup = dynamic(
  () =>
    import("@/components/newPageComponent/CommonSection/NewInactivityPopup"),
  { ssr: false },
);

const DesktopPage: React.FC = () => {
  return (
    <main className=" bg-white w-full">
      <EventTicker />
      <GlobalHeaderNew />
      <UspBannerDesktop />
      <UspHugeShortageDesktop />
      <UspSolutionDesktop />
      <UspWhatGlobalAccountantsDesktop />
      <UspROIDesktop />
      <UspRoadmap />
      <UspAlumniDesktop />
      <UspBlogs />
      <UspPoweredMilesDesktop />
      <UspFaq />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <Suspense fallback={<SectionSkeleton />}>
        <StickyFooterLabel pageName="USP" />
      </Suspense>
      <NewInactivityPopup pageName="CPA" courseId={1} delay={7000} />
      <QuickContact />
    </main>
  );
};

export default DesktopPage;
